import {
  CREATE_HOTEL_REQUEST,
  CREATE_HOTEL_SUCCESS,
  CREATE_HOTEL_FAIL,
  CREATE_HOTEL_RESET,
  GET_HOTELS_REQUEST,
  GET_HOTELS_SUCCESS,
  GET_HOTELS_FAIL,
  UPDATE_HOTEL_REQUEST,
  UPDATE_HOTEL_SUCCESS,
  UPDATE_HOTEL_FAIL,
  UPDATE_HOTEL_RESET,
  HIDE_HOTEL_FOR_WEB_REQUEST,
  HIDE_HOTEL_FOR_WEB_SUCCESS,
  HIDE_HOTEL_FOR_WEB_FAIL,
  HIDE_HOTEL_FOR_WEB_RESET,
  HIDE_HOTEL_FOR_PORTAL_REQUEST,
  HIDE_HOTEL_FOR_PORTAL_SUCCESS,
  HIDE_HOTEL_FOR_PORTAL_FAIL,
  HIDE_HOTEL_FOR_PORTAL_RESET,
  CLEAR_ERROR,
  GET_HOTEL_REQUEST,
  GET_HOTEL_SUCCESS,
  GET_HOTEL_FAIL,
  GET_HOTELS_PORTAL_REQUEST,
  GET_HOTELS_PORTAL_FAIL,
  GET_HOTELS_PORTAL_SUCCESS,
} from '../constants/hotelsConstant';

export const createHotel = (state = { data: {} }, action) => {
  switch (action.type) {
    case UPDATE_HOTEL_REQUEST:
    case CREATE_HOTEL_REQUEST:
    case HIDE_HOTEL_FOR_PORTAL_REQUEST:
    case HIDE_HOTEL_FOR_WEB_REQUEST:
      return {
        loading: true,
        success: false,
      };

    case UPDATE_HOTEL_SUCCESS:
    case CREATE_HOTEL_SUCCESS:
    case HIDE_HOTEL_FOR_WEB_SUCCESS:
    case HIDE_HOTEL_FOR_PORTAL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case UPDATE_HOTEL_FAIL:
    case CREATE_HOTEL_FAIL:
    case HIDE_HOTEL_FOR_PORTAL_FAIL:
    case HIDE_HOTEL_FOR_WEB_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case UPDATE_HOTEL_RESET:
    case CREATE_HOTEL_RESET:
    case HIDE_HOTEL_FOR_PORTAL_RESET:
    case HIDE_HOTEL_FOR_WEB_RESET:
      return {
        ...state,
        loading: false,
        success: false,
        error: null,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const getHotel = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_HOTEL_REQUEST:
    case GET_HOTELS_REQUEST:
    case GET_HOTELS_PORTAL_REQUEST:
      return {
        loading: true,
      };

    case GET_HOTELS_SUCCESS:
      return {
        ...state,
        loading: false,
        hotels: action.payload.hotels,
        totalHotels: action.payload.totalHotels,
      };

    case GET_HOTEL_SUCCESS:
      return {
        ...state,
        loading: false,
        hotel: action.payload.hotel,
        // totalFee : action.payload.totalFee
      };

    case GET_HOTELS_PORTAL_SUCCESS:
      return {
        ...state,
        loading: false,
        hotels: action.payload.hotels,
        // totalFee : action.payload.totalFee
      };

    case GET_HOTELS_FAIL:
    case GET_HOTEL_FAIL:
    case GET_HOTELS_PORTAL_FAIL:
      return {
        ...state,
        loading: false,
        hotels: null,
        hotel: null,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
